import { render, staticRenderFns } from "./fenzibiaozhi.vue?vue&type=template&id=9fe74c12&scoped=true&"
import script from "./fenzibiaozhi.vue?vue&type=script&lang=js&"
export * from "./fenzibiaozhi.vue?vue&type=script&lang=js&"
import style0 from "./fenzibiaozhi.vue?vue&type=style&index=0&id=9fe74c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe74c12",
  null
  
)

export default component.exports